module.exports = "/_next/static/images/case-tracker-screenshot-3-43112f5c9a7e0f7323844668ad5a91c6.png";